import { PreFlightStatus } from '@/api/preFlight/enumerations';

export const Constants = {
  pageTitle: 'Pré Flight',
  companiesLabel: 'Empresas solicitantes',
  companiesDescription:
    'Selecione uma empresa para visualizar as OS correspondentes',
  selectOsMessage: 'Selecione uma OS para ver os detalhes',
  errorMessage: 'Algo deu errado, tente novamente.',
  approvedSuccess: 'Solicitação aprovada com sucesso!',
  rejectedSuccess: 'Solicitação rejeitada.',
  updatedSuccess: 'Dados da OS atualizados com sucesso!',
  osPending: 'OS pendentes',
  noRequests: 'Nenhuma solicitação encontrada.',
  sourceLabel: 'Origem:',
  sourceFilterLabel: 'Filtrar por origem',
  completeOs: 'Entregar o laudo',
  attachmentsTitle: 'Anexar documentos e concluir a OS',
  attachmentsReportLabel: 'Laudo finalizado (PDF, obrigatório)',
  attachmentsOthersLabel: 'Outros documentos (opcional)',
  attachmentsDropReport: 'Clique para selecionar ou arraste o laudo',
  attachmentsDropReportFormat: 'Formato permitido: PDF',
  attachmentsDropOthers: 'Clique para selecionar ou arraste os documentos',
  attachmentsDropOthersFormat: 'Você pode selecionar mais de um arquivo',
  attachmentsDropActive: 'Solte o arquivo aqui',
  attachmentsChangeReport: 'Trocar o laudo',
  attachmentsRemove: 'Remover',
  attachmentsFooterHint: 'Escolha o laudo para liberar a entrega',
  attachmentsCancel: 'Cancelar',
  attachmentsSending: 'Enviando...',
  attachmentsReportRequired:
    'Selecione o laudo: é ele que conclui a OS e volta para a origem.',
  attachmentsCompleteFailed:
    'Não foi possível concluir a OS. Os documentos anexados foram mantidos.',
  attachmentsPartial: 'Não foi possível anexar:',
  completeOsFileLabel: 'Selecionar o PDF do laudo',
  completeOsOnlyPdf: 'O laudo precisa ser um PDF.',
  completeOsSuccess:
    'Laudo registrado. A OS foi concluída e a origem já foi avisada.',
  allSourcesLabel: 'Todas as origens',
  osPrefix: 'OS',
  propertyTypeLabel: 'Tipo do imóvel:',
  propertyUseLabel: 'Uso do imóvel:',
  calculationTypeLabel: 'Tipo de cálculo:',
  addressCardLabel: 'Endereço:',
  statusLabels: {
    pending: 'aguardando',
    approved: 'aprovado',
    rejected: 'rejeitado',
  } as Record<PreFlightStatus, string>,
  fillFieldMessage: 'Preencha o campo:',
  selectFieldMessage: 'Selecione o campo:',
  fileDeletedSuccess: 'Arquivo deletado!',
  addFileWarning: 'Adicione um arquivo!',
  fileFormatError: 'Formato incorreto, selecione uma imagem ou pdf',
  fileAddedSuccess: 'Arquivo adicionado com sucesso!',
  descriptionLabel: 'descrição',
  fileLabel: 'arquivo',
  noAttachments: 'sem arquivos em anexo',
  downloadFile: 'Baixar arquivo',
  fileFormats: 'PDF, JPG ou PNG',
  noDeedFile: 'nenhum arquivo de mátricula salvo',
  yes: 'Sim',
  no: 'Não',
  approvedStatus: 'aprovado',
  rejectedStatus: 'Rejeitado',
  replaceFile: 'Substituir arquivo',
  addFile: 'Adicionar arquivo',
  confirmReplace: (oldName: string, newName: string): string =>
    `substituir o arquivo ${oldName} por ${newName}`,
  confirmAdd: (filename: string): string => `adicionar o arquivo ${filename}`,
  confirmQuestion: (text: string): string => `Você gostaria de ${text}?`,
  requester: 'Solicitante',
  purpose: 'Finalidade',
  report: 'Laudo',
  companion: 'Acompanhante da vistoria',
  address: 'Endereço do imóvel',
  registration: 'Matrícula do imóvel',
  artRrt: 'ART/RRT',
  complementaryServices: 'Serviços complementares',
  documents: 'Documentos e anexos',
  requesterName: 'solicitante',
  name: 'nome',
  phone: 'telefone',
  email: 'e-mail',
  goal: 'objetivo',
  propertyType: 'tipo do imóvel',
  concept: 'conceito de espaço',
  modality: 'modalidade',
  calculationType: 'tipo de cálculo',
  street: 'logradouro',
  number: 'número',
  complement: 'complemento',
  zipCode: 'CEP',
  district: 'bairro',
  city: 'cidade',
  state: 'estado',
  registrationNumber: 'número da matrícula',
  registrationFile: 'Arquivo da matrícula',
  artModality: 'modalidade da ART/RRT',
  technicalReview: 'Revisão técnica independente',
  newRegistration: 'Nova matrícula',
  editOs: 'editar OS',
  cancelEdit: 'cancelar edição',
  confirmChanges: 'confirmar alterações',
  rejectOs: 'reprovar OS',
  approveOs: 'aprovar OS',
  selectFile: 'selecionar arquivo',
  add: 'adicionar',
  cancel: 'cancelar',
  confirm: 'confirmar',
  approveConfirmText:
    'A OS será enviada para o Hive para atribuição ao credenciado.',
  undoText: 'Atenção! Esta ação não poderá ser desfeita.',
  rejectTitle: 'Reprovar OS',
  rejectConfirmText:
    'A OS será devolvida para quem a solicitou, informe o motivo da reprovação.',
  rejectReasonLabel: 'Motivo:',
  rejectReasonPlaceholder: 'Escreva o motivo da reprovação',
  files: 'arquivos',
  searchMap: 'pesquisar no mapa',
  mapUpdated: 'mapa atualizado',
  fieldsIncomplete: 'Preencha os campos obrigatórios do endereço',
  searchMapBeforeSave: 'Pesquise a localização no mapa antes de salvar.',
};
